import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from 'src/app/common/utils';
import { AllPatient } from 'src/app/models/patient';
import { Physician } from 'src/app/models/physician';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { TrimFormValuesService } from 'src/app/common/trimmingForm';
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: 'app-presc-temp-edit',
  templateUrl: './presc-temp-edit.component.html',
  styleUrls: ['./presc-temp-edit.component.css']
})
export class PrescTempEditComponent implements OnInit {
  @ViewChild('showeditprescModal', { static: true } as any) showeditprescModal: TemplateRef<any>;

  prescription: UntypedFormArray;
  intakeFreqTypesList = Utils.INTAKE_FREQ_TYPE_LIST;
  intakefreqList: any = [];
  drid: any;
  cate: any;
  org_code: any;
  prescriptionForm: UntypedFormGroup;
  intakeList = Utils.INTAKE;
  patient: AllPatient;
  prescriptions: any;
  physicianDetail: Physician;

  medicineAuo: any;
  text = "";
  medicneAuo_id: any;
  medicneAuo_type: any;


  tmpl_search_form: UntypedFormGroup;
  newarr: any[];
  tmpl: any;
  unique: unknown[];

  constructor(

    private utils: Utils,
    private _formBuilder: UntypedFormBuilder,

    private service: VproService,
    private spinner: NgxSpinnerService,
    private modal: NgbModal,
    private trimFormValuesService: TrimFormValuesService,
  ) {
  }



  ngOnInit() {

    this.tmpl_search_form = this._formBuilder.group({
      tmpl_name: [''],
    })




    this.prescriptionForm = this._formBuilder.group({

      pre_template_details: this._formBuilder.array([]),


    });

    this.getPhysicianDetails();
    this.addpPrescription();

  }

  addpPrescription() {
    this.prescription = this.prescriptionForm.get(
      "pre_template_details"
    ) as UntypedFormArray;
    this.prescription.push(this.createpPrescription());
    this.intakefreqList.push([]);
  }

  createpPrescription(): UntypedFormGroup {
    return this._formBuilder.group({
      mname: [""],
      strength: [""],
      intake: [""],
      intakefreq: [""],
      intakefreq_type: [""],

    });
  }

  public removingCurrentPrescription(i: number): void {
    this.prescription.removeAt(i);
  }

  track(item: any, index: number) {
    return index;
  }

  freqTypeSelected(event, i) {
    this.intakeFreqTypesList.forEach((type) => {
      console.log("type", type.value);
      console.log("event", event.target.value);
      if (type.value == event.target.value)
        this.intakefreqList[i] = type.freq_options;
    });
    this.prescription.at(i).get("intakefreq").reset();
    if (event.target.value === "Whenever Required") {
      this.prescription
        .at(i)
        .get("intakefreq")
        .setValue(this.intakeFreqTypesList[2].freq_options[0]);
      this.prescription.at(i).get("intakefreq").updateValueAndValidity();
    }
  }



  getControl(field: string): UntypedFormControl {
    return this.prescriptionForm.get(field) as UntypedFormControl;
  }

  getControlLabel(type: number) {
    return this.prescriptionForm.controls[type].value;
  }


  medicinesFet(e) {
    let medi = e.target.value

    if (e.target.value.length >= 3) {
      let medicine = medi;
      let val = { medicine: medicine }
      if (val.medicine === '') {
        delete val.medicine;
      }
      this.service
        .fetchMedicineRecords(val)
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.medicineAuo = res;
            console.log("CATEGORY", this.medicineAuo);
            this.medicneAuo_id = this.medicineAuo[0].med_id;
            this.medicneAuo_type = this.medicineAuo[0].med_type;


          },
          (error) => {
            this.spinner.hide();
            Utils.showToast("error", "Something went wrong. Please try again.");
          }
        );
    }
  }

  sendPrescription(id) {
    let data = this.prescriptionForm.value;

    this.prescriptionForm.value.pre_template_details[0].med_id = this.medicneAuo_id;
    this.prescriptionForm.value.pre_template_details[0].med_type = this.medicneAuo_type;

    // console.log("texxt", this.prescriptionForm.value.pre_template_details[0])
    // console.log(this.medicneAuo_id);
    // console.log(this.medicneAuo_type);


    console.log("DATAAAAAA..", data);

    this.spinner.show();
    this.service
      .editnewPresctmpl(id, data)
      .subscribe((result) => {
        this.spinner.hide();
        Utils.showToast("success", "Medicine  added successfully");
        this.refresh();
      });


  }

  setFormValidators(i = 0) {
    if (
      this.prescription.at(i).get("mname").value !== "" ||
      this.prescription.at(i).get("strength").value !== "" ||
      this.prescription.at(i).get("intake").value !== "" ||
      this.prescription.at(i).get("intakefreq").value !== "" ||
      this.prescription.at(i).get("intakefreq_type").value !== ""
    ) {
      this.prescription.at(i).get("mname").setValidators(Validators.required);
      this.prescription
        .at(i)
        .get("strength")
        .setValidators(Validators.required);
      this.prescription
        .at(i)
        .get("intake")
        .setValidators([Validators.required]);
      this.prescription
        .at(i)
        .get("intakefreq")
        .setValidators([Validators.required]);
      this.prescription
        .at(i)
        .get("intakefreq_type")
        .setValidators([Validators.required]);
      if (!this.prescription.at(i).get("sdate").value)
        this.prescription.at(i).get("sdate").setErrors({ required: true });
      if (!this.prescription.at(i).get("edate").value)
        this.prescription.at(i).get("edate").setErrors({ required: true });
    } else {
      this.prescription.at(i).get("mname").clearValidators();
      this.prescription.at(i).get("strength").clearValidators();
      this.prescription.at(i).get("intake").clearValidators();
      this.prescription.at(i).get("intakefreq").clearValidators();
      this.prescription.at(i).get("intakefreq_type").clearValidators();
    }
    this.prescription.at(i).get("mname").updateValueAndValidity();
    this.prescription.at(i).get("strength").updateValueAndValidity();
    this.prescription.at(i).get("intake").updateValueAndValidity();
    this.prescription.at(i).get("intakefreq").updateValueAndValidity();
    this.prescription.at(i).get("intakefreq_type").updateValueAndValidity();
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }

  gotoPage() {
    //this.router.navigate(["/appointment/consultation"]);
  }

  getPhysicianDetails() {
    this.service.getPhysicianById(localStorage.getItem("uid")).subscribe(
      (result) => {

        this.physicianDetail = result;
        this.drid = result.u_id;
        this.org_code = result.org_code;
        console.log("this.drid", this.drid);
        console.log("this.org_code", this.org_code);
      },
      (error) => {
        console.log(error);
      }
    );
  }



  enterSubmit(event) {
    if (event.keyCode == 13 && !event.shiftKey) {
      //Stops enter from creating a new line
      event.preventDefault();
      return true;
    }
  }



  getpresctempl() {
    this.spinner.show();
    this.service
      .getPhysicianById(localStorage.getItem("uid"), "?fields=pre_template_uid")
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.cate = res;
          //console.log("CATE", this.cate);
          console.log("templates", this.cate.pre_template_uid);
        },
        (error) => {
          console.log(error);
        }
      );

  }

  // Delete the medicine from Prescription template.
  delPresc(id) {

    this.spinner.show();
    this.service
      .editPresctmpl(id)
      .subscribe(
        (res) => {
          this.spinner.hide();
          // SweetAlert
          Utils.showToast('success', "Prescription Deleted successfuly");
          //this.findPatient(this.page);
          this.refresh();
        },
        (error) => {
          //this.spinner.hide();
          let message;
          if (error && error.error && error.error.message && error.error.message.message) {
            message = error.error.message.message;
          }
          else message = "Something went wrong. Couldn't update profile."
          Utils.showToast('error', message);
        }
      );

  }

  refresh(): void {
    window.location.reload();
  }

  // SEARCH TEMPLATE from search button click
  searchtmpl() {
    let data = { ...this.tmpl_search_form.value };

    data.drid = parseInt(localStorage.getItem("uid"));
    if (data.tmpl_name == "") {
      delete data.tmpl_name;
    }
    console.log(data);
    this.trimFormValuesService.trimValues(data);
    this.spinner.show();
    this.service
      .sarchpresTempl(data)
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.cate = res;
          console.log("templatessss", this.cate);

          this.unique = [...new Map(this.cate.map((m) => [m.tmpl_id, m])).values()];

          console.log("unique", this.unique);

          this.newarr = [this.cate[0]];
          for (var i = 1; i < this.cate.length; i++) {
            if (this.cate[i].tmpl_id != this.cate[i - 1].tmpl_id)
              this.newarr.push(this.cate[i]);
          }


          console.log("newarr", this.newarr);
        },
        (error) => {
          console.log(error);
        }
      );

  }


  showeditpresc(tmpl_name) {
    // this.editcateid = med_cate_id;
    // this.editcate = med_cate;
    // console.log(this.editcateid);
    // // this.fetchservicereport(aid, pid);
    console.log("tmpl_name", tmpl_name);
    //console.log("tmpl_id", name);
    // this.prescriptionForm.patchValue({
    //   tmpl_name: name,
    //   tmpl_id: id
    // });

    let data = {
      tmpl_name: tmpl_name,
      drid: parseInt(localStorage.getItem("uid"))
    };


    console.log("dataaaa", data);
    this.spinner.show();
    this.service
      .sarchpresTempl(data)
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.tmpl = res;
          console.log("templatessss", this.tmpl);
        },
        (error) => {
          console.log(error);
        }
      );


    this.modal.open(this.showeditprescModal, { size: 'lg', centered: true, backdrop: 'static' });

  }





}